import { cn } from "@/common/utils/css.utils";
import {
  RadioButton,
  RadioButtonProps,
} from "@/ui/cva/radio-button/RadioButton";
import { ActionLabel } from "@/ui/typography/ActionLabel";
import { forwardRef, Ref } from "react";

type RadioButtonLabelBaseProps = {
  elementRef?: Ref<HTMLInputElement>;
  label: string;
  valid?: boolean;
} & RadioButtonProps;

const RadioButtonLabelBase = ({
  elementRef,
  label,
  color,
  valid = true,
  disabled,
  ...props
}: RadioButtonLabelBaseProps) => {
  return (
    <ActionLabel
      className={cn(
        "flex items-center gap-2",
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      )}
    >
      <RadioButton
        ref={elementRef}
        {...props}
        color={color}
        valid={valid}
        disabled={disabled}
      />
      <span>{label}</span>
    </ActionLabel>
  );
};

RadioButtonLabelBase.displayName = "RadioButtonLabel";

export type RadioButtonLabelProps = Omit<
  RadioButtonLabelBaseProps,
  "elementRef"
>;

/**
 * Label component that should be used to wrap the radio button.
 */
export const RadioButtonLabel = forwardRef<
  HTMLInputElement,
  RadioButtonLabelProps
>((props, ref) => <RadioButtonLabelBase {...props} elementRef={ref} />);
